import type { IAddress } from './types';

export function AddressFactory(extraProps?: Partial<IAddress>): IAddress {
  return {
    id: 1,
    full_name: 'Bilbo Baggins',
    line1: '123 Underhill Way',
    city: 'The Shire',
    state: 'MA',
    postal_code: '00100',
    country: 'US',
    phone_country: 'US',
    phone_number: '9876543210',
    ...extraProps,
  };
}
